export function getAge(
	birthDateString: string | null | undefined,
	at?: string,
) {
	if (!birthDateString) return undefined
	const birthDate = new Date(birthDateString)
	const atDate = at ? new Date(at) : new Date()
	let years = atDate.getFullYear() - birthDate.getFullYear()

	// Adjust if birthday hasn't occurred until at date
	const monthDiff = atDate.getMonth() - birthDate.getMonth()
	const dayDiff = atDate.getDate() - birthDate.getDate()

	if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
		years--
	}

	return years
}
